module.exports = __webpack_public_path__ + "static/mr-concert-performance-09-e11de791e3749ba24bb418face5e4332.jpg";